import columns from "./columns";
import searchFields from "./searchFields";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "devices",
    pageTitle: "Devices",
    columns,
    searchFields,
    searchPlaceholder: "e.g. name:joe",
    formFields,
    previewFields,
    tableOptions: {},
    formOptions: {},
};
